import React, {useState} from 'react';
import Error from './Error';
import shortid from 'shortid';

const Formulario = ({agregarNuevoGasto ,guardarRestante ,restante}) => {


    const [nombre, guardarNombre] = useState('');
    const [Cantidad, guardarCantidad] = useState(0);
    const [error, setError] = useState(false);


    //Funciones

    const agregarGasto= e =>{
        e.preventDefault();
        //Validar

        if (Cantidad<1 || isNaN(Cantidad)|| nombre.trim()==='') {
            setError(true);
            return;
        }

        setError(false);

        //Construir el Gasto
            const gasto = {
                nombre,
                Cantidad,
                id: shortid.generate()
                
            }
        //Pasar al componente principal

        agregarNuevoGasto(gasto);

        

        //reset form

        guardarCantidad(0);
        guardarNombre("");
        guardarRestante(restante-gasto.Cantidad)

    }



    return ( 
        <form 
            onSubmit= {agregarGasto}
        >
            <h2>Agrega tus gastos aqui</h2>

            {error ? <Error mensaje= "Ambos campos son obligatorios o presupuesto Incorrecto" /> : null}

            <div className="campo">
                    <label>Nombre Gasto</label>
                    <input
                    type="text"
                    className="u-full-width"
                    placeholder="Ej. Transporte"
                    value={nombre}
                    onChange={e=> guardarNombre(e.target.value)}
                    />
            </div>
            <div className="campo">
                    <label>Cantidad  Gasto</label>
                    <input
                    type="number"
                    className="u-full-width"
                    placeholder="Ej. 300"
                    value= {Cantidad}
                    onChange = {e=> guardarCantidad(parseInt(  e.target.value))}
                    />
            </div>

            <input
            type="submit"
            className="button-primary u-full-width"
            value="Agregar Gasto"
            />
        </form>

     );
}
 
export default Formulario;